import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap';
import Api from '../../../../../Global/Modules/Api'
import { Link } from 'react-router-dom';
const FETCH_URL = "api/educations/meetingadmin"

class OnbekendeBijeenkomst extends Component {

    constructor() {
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.emptyForm = this.emptyForm.bind(this)

        this.state = {
            data: {
                institution: '',
                type: '',
                city: '',
                name: '',
                date: '',
                hours: ''
            },
            errors: {}
        }
    }

    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ data: { ...this.state.data, [name]: [value] } })
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()

        var formData = new FormData()
        Object.keys(this.state.data).forEach(e => {
            formData.append(e, this.state.data[e])
        })
        formData.append('MemberId', this.props.id)
        const file = this.fileInput.files[0]
        formData.append('file', file === undefined ? null : file)

        // Post formData to the API
        Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
            .then(data => {
                if (data !== undefined)
                    this.setState({ errors: data });

                else {
                    alert("Onbekende bijeenkomst added")
                    this.emptyForm()
                }
            })
    }

    emptyForm() {
        // TODO: Show some kind of message so the user knows that something has been created
        Api.print('Emptying form')
        const emptyData = {
            institution: '',
            type: '',
            city: '',
            name: '',
            date: '',
            hours: ''
        }

        this.setState({ data: emptyData })
    }

    render() {
        let errors = this.state.errors
        return (
            <Form horizontal onSubmit={this.handleSubmit}>
                <FormGroup controlId="OnbekendeBijeenkomstNaam">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam bijeenkomst / lezing / symposium / projectbezoek
                    </Col>
                    <Col sm={6}>
                        <FormControl name="name" type="text" value={this.state.data.name} onChange={this.handleChange} required />
                        {Api.showError(errors, "name")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeBijeenkomstType">
                    <Col componentClass={ControlLabel} sm={4}>
                        Type
                    </Col>

                    <Col sm={6}>
                        <FormControl name="type" componentClass="select" value={this.state.data.type} onChange={this.handleChange} required>
                            <option value="">selecteer</option>
                            <option value="0">volledige technische studiedag</option>
                            <option value="1">studiemiddag</option>
                            <option value="2">excursie</option>
                            <option value="3">aanpalend college</option>
                        </FormControl>
                        {Api.showError(errors, "type")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeBijeenkomstPlaats">
                    <Col componentClass={ControlLabel} sm={4}>
                        Plaats
                    </Col>
                    <Col sm={6}>
                        <FormControl name="city" type="text" value={this.state.data.city} onChange={this.handleChange} required />
                        {Api.showError(errors, "city")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeBijeenkomstDatum">
                    <Col componentClass={ControlLabel} sm={4}>
                        Datum (dd-mm-jjjj)
                    </Col>
                    <Col sm={6}>
                        <FormControl name="date" type="text" value={this.state.data.date} onChange={this.handleChange} required />
                        {Api.showError(errors, "date")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeBijeenkomstOrganisator">
                    <Col componentClass={ControlLabel} sm={4}>
                        Organisator
                    </Col>
                    <Col sm={6}>
                        <FormControl name="institution" type="text" value={this.state.data.institution} onChange={this.handleChange} required />
                        {Api.showError(errors, "institution")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeBijeenkomstDuur">
                    <Col componentClass={ControlLabel} sm={4}>
                        Duur (uren)
                    </Col>
                    <Col sm={6}>
                        <FormControl name="hours" type="text" value={this.state.data.hours} onChange={this.handleChange} required />
                        {Api.showError(errors, "hours")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeBijeenkomstDeelnamebewijs">
                    <Col componentClass={ControlLabel} sm={4}>
                        Deelnamebewijs
                    </Col>
                    <Col sm={6}>
                        <FormControl type="File" inputRef={input => this.fileInput = input} />
                        {Api.showError(errors, "file")}
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col sm={2}>
                        <Link to={'/admin/leden/lid/kennis/' + this.props.id} className="btn btn-default">Terug</Link>
                    </Col>
                    <Col smOffset={8} sm={2}>
                        <Button type="submit">Voeg Toe</Button>
                    </Col>
                </FormGroup>
            </Form>
        );
    }
}

export default OnbekendeBijeenkomst;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/Toevoegen/OnbekendeBijeenkomst.js